export function frontHero(root = document) {
    const heroes = root.querySelectorAll('[data-front-hero]');

    if (!heroes.length) return;

    heroes.forEach((hero) => {
        const visual = hero.querySelector('[data-front-hero-visual]');
        const content = hero.querySelector('[data-front-hero-content]');

        if (!visual) return;

        const media = gsap.matchMedia();

        media.add('(min-width: 768px) and (prefers-reduced-motion: no-preference)', () => {
            const timeline = gsap.timeline({
                defaults: { ease: 'none' },
                scrollTrigger: {
                    trigger: hero,
                    start: 'top top',
                    end: 'bottom bottom',
                    scrub: true,
                    invalidateOnRefresh: true,
                },
            });

            timeline
                .to(content, { autoAlpha: 0, duration: 0.35 }, 0)
                .to(visual, {
                    right: 0,
                    top: '100svh',
                    width: '100%',
                    height: '100svh',
                    duration: 1,
                }, 0);

            // Hold the completed video expansion for a short extra scroll distance.
            // Pin the hero so the animated visual keeps its existing positioning.
            const hold = ScrollTrigger.create({
                trigger: hero,
                start: 'bottom bottom',
                end: () => `+=${window.innerHeight * 0.35}`,
                pin: true,
                pinSpacing: true,
                invalidateOnRefresh: true,
            });

            return () => {
                hold.kill();
                timeline.revert();
            };
        });
    });
}
